import { PageParams } from '../../../../routes'

export const getFilteredCrScamsArticleListingDataLayerData = (
  pageInfo: Record<string, any>,
  categorySlug: PageParams['categorySlug']
) => {
  const crArticleDataLayerItems: any = {
    ...pageInfo,
    topicName: 'scams',
    subtopicName: 'how-to-spot-a-scam',
    content_type: getCRScamsContentType(categorySlug),
  }

  delete crArticleDataLayerItems.sub_vertical
  delete crArticleDataLayerItems.category

  return crArticleDataLayerItems
}

///////// IMPLEMENTATION /////////

type ContentType = 'Consumer Rights - advice listing' | 'Consumer Rights - news listing'

const getCRScamsContentType = (categorySlug: PageParams['categorySlug']): ContentType => {
  if (categorySlug === 'scam-and-fraud') {
    return 'Consumer Rights - news listing'
  }

  return 'Consumer Rights - advice listing'
}
